import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import InstallWebPackageManagers from "./install-web-package-managers.mdx";
import Tab from "components/Tab";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Install `}<inlineCode parentName="p">{`posthog-js`}</inlineCode>{` using your package manager:`}</p>
    <InstallWebPackageManagers mdxType="InstallWebPackageManagers" />
    <h3 {...{
      "id": "initialize-the-posthog-client"
    }}>{`Initialize the PostHog client`}</h3>
    <p>{`Generate environment files for your project with `}<inlineCode parentName="p">{`ng g environments`}</inlineCode>{`. Configure the following environment variables:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`posthogKey`}</inlineCode>{`: Your project API key from your `}<a parentName="li" {...{
          "href": "https://app.posthog.com/settings/project#variables"
        }}>{`project settings`}</a>{`.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`posthogHost`}</inlineCode>{`: Your project's client API host. Usually `}<inlineCode parentName="li">{`https://us.i.posthog.com`}</inlineCode>{` for US-based projects and `}<inlineCode parentName="li">{`https://eu.i.posthog.com`}</inlineCode>{` for EU-based projects.`}</li>
    </ul>
    <Tab.Group tabs={['Angular v17+', 'Angular v16 and below']}>
      <Tab.List>
  <Tab mdxType="Tab">Angular v17+</Tab>
  <Tab mdxType="Tab">Angular v16 and below</Tab>
      </Tab.List>
      <Tab.Panels>
  <Tab.Panel>
          <p>{`  For Angular v17 and above, you can set up PostHog as a singleton service. To do this, start by creating and injecting a `}<inlineCode parentName="p">{`PosthogService`}</inlineCode>{` instance.`}</p>
          <p>{`  Create a service by running `}<inlineCode parentName="p">{`ng g service services/posthog`}</inlineCode>{`. The service should look like this:`}</p>
          <pre><code parentName="pre" {...{
              "className": "language-ts",
              "metastring": "file=posthog.service.ts",
              "file": "posthog.service.ts"
            }}>{`// src/app/services/posthog.service.ts
import { DestroyRef, Injectable, NgZone } from "@angular/core";
import posthog from "posthog-js";
import { environment } from "../../environments/environment";
import { Router } from "@angular/router";

@Injectable({ providedIn: "root" })
export class PosthogService {
  constructor(
    private ngZone: NgZone,
    private router: Router,
    private destroyRef: DestroyRef,
  ) {
    this.initPostHog();
  }
  private initPostHog() {
    this.ngZone.runOutsideAngular(() => {
      posthog.init(environment.posthogKey, {
        api_host: environment.posthogHost,
        defaults: '<ph_posthog_js_defaults>',
      });
    });
  }
}
`}</code></pre>
          <p>{`  The service is initialized `}<a parentName="p" {...{
              "href": "https://angular.dev/api/core/NgZone#runOutsideAngular"
            }}>{`outside of the Angular zone`}</a>{` to reduce change detection cycles. This is important to avoid performance issues with session recording.`}</p>
          <p>{`  Then, inject the service in your app's root component `}<inlineCode parentName="p">{`app.component.ts`}</inlineCode>{`. This will make sure PostHog is initialized before any other component is rendered.`}</p>
          <pre><code parentName="pre" {...{
              "className": "language-ts",
              "metastring": "file=app.component.ts",
              "file": "app.component.ts"
            }}>{`// src/app/app.component.ts
import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { PosthogService } from "./services/posthog.service";

@Component({
  selector: "app-root",
  styleUrls: ["./app.component.scss"],
  template: \`
    <router-outlet />\`,
  imports: [RouterOutlet],
})
export class AppComponent {
  title = "angular-app";

  constructor(posthogService: PosthogService) {}
}
`}</code></pre>
  </Tab.Panel>
  <Tab.Panel>
          <p>{`  In your `}<inlineCode parentName="p">{`src/main.ts`}</inlineCode>{`, initialize PostHog using your project API key and instance address. You can find both in your `}<a parentName="p" {...{
              "href": "https://us.posthog.com/project/settings"
            }}>{`project settings`}</a>{`.  `}</p>
          <pre><code parentName="pre" {...{
              "className": "language-ts",
              "metastring": "file=main.ts",
              "file": "main.ts"
            }}>{`// src/main.ts
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from "./environments/environment"; // +
import posthog from 'posthog-js' // +

posthog.init(environment.posthogKey, { // +
  api_host: environment.posthogHost, // +
  defaults: '<ph_posthog_js_defaults>' // +
}) // +

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
`}</code></pre>
  </Tab.Panel>
      </Tab.Panels>
    </Tab.Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      